<div class="n-layout-agenda">
  <!-- Calendário fixo no topo (mobile) / lateral (desktop) -->
  <div class="n-filtro-card n-desktop">
    <div class="n-calendario-wrapper relative">
      <div class="n-desktop">
        <lib-agenda-filtro-calendario
          [$mostrarConteudo]="menuVisivel"
        ></lib-agenda-filtro-calendario>
      </div>
      <div class="n-mobile">
        <lib-calendario-semanal></lib-calendario-semanal>
      </div>

      <div class="n-notificacoes">
        <lib-agenda-notificacao></lib-agenda-notificacao>
      </div>

      <!-- Botão toggle apenas no mobile -->
      <div class="sm:block md:hidden">
        <div class="flex justify-center mt-2">
          <p-button
            [text]="true"
            [rounded]="true"
            size="small"
            severity="secondary"
          >
          </p-button>
        </div>
      </div>

      <button class="n-nav-toggle" (click)="toggleMenu()">
        @if(menuVisivel) {
        <i class="pi pi-chevron-up"></i>
        } @else {
        <i class="pi pi-chevron-down"></i>
        }
      </button>
    </div>
  </div>

  <div class="n-mobile">
    <lib-calendario-semanal></lib-calendario-semanal>
  </div>

  <!-- Lista de agendamentos -->
  <div class="n-lista">
    <!-- Header com ações -->
    <div class="n-header-acoes">
      <!-- Grupo de botões de ação -->
      <div class="n-grupo-botoes">
        <p-button
          icon="pi pi-plus"
          severity="primary"
          size="small"
          [rounded]="true"
          data-tour="agenda-novo"
          (onClick)="novoAgendamento()"
          [disabled]="agendaDataService.$desabilitarNovoAgendamento()"
          [pTooltip]="$termos().agendamento.btnNovo"
          tooltipPosition="bottom"
        >
        </p-button>

        <!-- TODO: Reativar disabled quando services estiverem disponíveis -->
        <!-- [disabled]="agendaCalendarioService.$desabilitarNovoAgendamento() || !pwaOnlineStatusService.$isOnline()" -->

        <!-- Botão de Encaixe: agendamento extraordinário fora da disponibilidade padrão -->
        @if ($podeCriarEncaixe()) {
          <p-button
            icon="pi pi-bolt"
            severity="help"
            size="small"
            [rounded]="true"
            (onClick)="novoEncaixe()"
            [disabled]="agendaDataService.$desabilitarNovoAgendamento()"
            [pTooltip]="'BARDO_AGENDA.ENCAIXE_LABEL' | translate"
            tooltipPosition="bottom"
          >
          </p-button>
        }

        <!-- Botão de filtro apenas para ADMINISTRADOR e RECEPCAO -->
        @if (bardoContextDataService.$perfilAtivo() !== 'PROFISSIONAL') {
          <p-button
            [rounded]="true"
            (click)="toggleFiltro($event)"
            icon="pi pi-filter"
            severity="secondary"
            size="small"
            data-tour="agenda-filtros"
            [styleClass]="$filtroPreenchido()"
            #btnFiltro
          >
          </p-button>
        }

        <!-- Bottom Sheet com filtros (mobile) -->
        @if (deviceService.$isMobile()) {
        <lib-bottom-sheet
          [visible]="$filtroSheetVisible()"
          (visibleChange)="$filtroSheetVisible.set($event)"
          size="medium"
          [showHandle]="true"
          [headerTemplate]="filtroHeaderTpl"
        >
          <lib-agenda-filtro></lib-agenda-filtro>
        </lib-bottom-sheet>

        <ng-template #filtroHeaderTpl>
          <span class="font-semibold text-lg">{{ 'BARDO_AGENDA.FILTRO' | translate }}</span>
        </ng-template>
        }

        <!-- Popover com filtros adicionais (desktop) -->
        <p-popover #openPopOver styleClass="custom-popover">
          <ng-template #content>
            <div class="p-3">
              <lib-agenda-filtro></lib-agenda-filtro>
            </div>
          </ng-template>
        </p-popover>
      </div>

      <!-- Informação da data selecionada -->
      <div class="n-info-data">
        <h5>
          {{
            agendaDataService.$dataSelecionada() | date : 'dd MMM y' : undefined : i18nService.$locale()
          }}
        </h5>
        <!-- TODO: Converter para @if (Angular 19) -->
        @if($feriado()) {
        <p-tag
          icon="pi pi-calendar"
          severity="warn"
          [value]="$feriado()"
          size="small"
        >
        </p-tag>
        }
      </div>
    </div>

    <!-- Lista de agendamentos -->
    <div class="flex-1 overflow-auto">
      <lib-agenda-lista-agendamento></lib-agenda-lista-agendamento>
    </div>
  </div>
</div>
<lib-agenda-modal-novo-agendamento
  [($modalIsVisible)]="$modalCadastroVisible"
  [isEncaixe]="$modalEncaixe()"
></lib-agenda-modal-novo-agendamento>

<!-- Modal de Informações do Agendamento -->
<lib-agenda-modal-informacao-agendamento
  [($modalIsVisible)]="$modalInformacaoVisible"
  [agendamento]="agendamentoModal"
></lib-agenda-modal-informacao-agendamento>
